import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { Input, Select, PhoneInput, DatePicker, Textarea, MultiSelect, AutoCompleteSelect } from '../../../itrust_common/components/form'
import { getCustomLabel } from '../../../itrust_common/components/HelperFunctions';
import { SaveButton } from '../../../itrust_common/components/others';
import AutoComplete from '../../../itrust_common/components/others/AutoComplete';
import { patientLoad } from '../../../redux/actions/patient/patientActions';
import PatientInfo from './PatientInfo'
import { email, required } from '../../../itrust_common/components/form/FormValidations';
import { lowercase, capitalizeFirstLetter } from '../../../itrust_common/components/form/FormNormalize';
import ScrollToTarget from '../../../itrust_common/components/others/ScrollToTarget';
import { onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import PatientModeOfNotification from '../../../itrust_common/components/form/PatientModeOfNotification';
import { STATUSES } from '../../../itrust_common/components/Constants';
import AppointmentStartEndTime from './AppointmentStartEndTime';
import Moment from 'moment';
import TabAppointment from './TabAppointment';

class BookAppointmentForm extends Component {
  constructor(props) {
    super(props);
    this.handeSearchResultClose()
  }

  handlePatientLoad(id) {
    this.props.dispatch(patientLoad(id, { include: ['patient_medical_insurance', 'patient_vision_insurance'] }))
  }

  handleSearchResult(id) {
    this.handlePatientLoad(id)
    this.props.handleAppointmentEditHandler({ formType: 'existing' })
    this.props.dispatch(change('appointmentForm', 'patient_id', id))
  }

  handeSearchResultClose() {
    this.props.handleAppointmentEditHandler({ formType: 'default' });
    this.props.dispatch(change('appointmentForm', 'patient_id', ''))
  }

  handleIsFieldRequired(fieldName, isValidation) {
    const { patientBasicDetailsTemplate } = this.props
    return patientBasicDetailsTemplate?.[fieldName]?.required ? isValidation ? [required] : '*' : ''
  }

  handleAppointmentTour() {
    const { onBoarding: { stepIndex } } = this.props
    if (this.props.formType !== 'default') {
      // existing and new // move to step reason for visit
      stepIndex !== 2 && this.props.dispatch(onBoardingTourInfoUpdate({ stepIndex: 2, isTourActive: true, activeTourType: 'create_appointment' }))
    }
    else {
      // default
      stepIndex !== 1 && this.props.dispatch(onBoardingTourInfoUpdate({ stepIndex: 1, isTourActive: true, activeTourType: 'create_appointment' }))
    }
  }

  componentDidUpdate() {
    const { onBoarding: { isTourActive, activeTourType } } = this.props
    if (isTourActive && activeTourType === 'create_appointment') {
      this.handleAppointmentTour()
    }
  }

  render() {
    const { staffs, appointment, handleSubmit, handleAppointmentEditHandler, patient, saving, formType, procedures, isFullMode, selectedVisionInsuranceId, selectedMedicalInsuranceId, visionInsuranceTemplate, medicalInsuranceTemplate, onBoarding: { isTourActive }, isQuickAction } = this.props
    return (
      <form onSubmit={handleSubmit} className={`appointment-step-2 ${isFullMode && 'overflow-auto overflow-x-hidden height-54'}`}>
        <TabAppointment staffs={staffs} isNew={true} tab_appointment={appointment.tab_appointment} />
        <div className="modal-body px-5 pt-1 pb-0">
          <AppointmentStartEndTime procedures={procedures} isQuickAction={isQuickAction} />
          {formType === 'default' &&
            <AutoComplete fieldName="patient" placeholder="Search patient by Name" key={patient.id} textField="name" valueField="id" onSelect={(id) => { this.handleSearchResult(id) }} klass="Patient" wrapperClasses="w-100 position-relative mb-5" />
          }
          {formType === 'existing' &&
            <div className="modal-body p-0">
              <PatientInfo patient={patient} handeSearchResultClose={this.handeSearchResultClose.bind(this)} />
            </div>
          }
          {(formType === 'new' && !isFullMode) && <div className="selected-patient">
            <div className="row w-100 m-0">
              <Field name="first_name" placeholder={`First Name ${this.handleIsFieldRequired("first_name")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-0 pr-3" validate={!isFullMode && required} normalize={capitalizeFirstLetter} />
              <Field name="last_name" placeholder={`Last Name ${this.handleIsFieldRequired("last_name")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-3 pr-0" normalize={capitalizeFirstLetter} validate={this.handleIsFieldRequired("last_name", true)} />
              <Field name="date_of_birth" component={DatePicker} wrapperClasses="form-group col-12 px-0" validate={this.handleIsFieldRequired('date_of_birth', true)} />
              <Field name="cell_phone" component={PhoneInput} className="form-control" wrapperClasses="form-group col-6 pl-0 pr-3" validate={this.handleIsFieldRequired('cell_phone', true)} />
              <Field name="email" normalize={lowercase} placeholder={`Email ${this.handleIsFieldRequired("email")}`} component={Input} className="form-control" wrapperClasses="form-group col-6 pl-3 pr-0" validate={[email, ...this.handleIsFieldRequired("email", true)]} />
              <Field name="patient_vision_insurance_attributes[settings_insurance_id]"
                label={visionInsuranceTemplate && getCustomLabel(visionInsuranceTemplate, 'insurance')} component={AutoCompleteSelect}
                textField="name" valueField="id"
                klass="Settings::Insurance"
                filter={{ insurance_type: 'vision', is_active: true }}
                wrapperClasses={` ${(selectedVisionInsuranceId !== null && selectedVisionInsuranceId !== undefined) ? 'col-6' : 'col-12'} form-group px-0`} />

              {(selectedVisionInsuranceId !== null && selectedVisionInsuranceId !== undefined) &&
                <Field name="patient_vision_insurance_attributes[member_id]" component={Input} label="Member ID" className="form-control" wrapperClasses="col-6 form-group pe-0" validate={[required]} />
              }

              <Field name="patient_medical_insurance_attributes[settings_insurance_id]"
                label={medicalInsuranceTemplate && getCustomLabel(medicalInsuranceTemplate, 'insurance')} component={AutoCompleteSelect}
                textField="name"
                valueField="id"
                klass="Settings::Insurance"
                filter={{ insurance_type: 'medical', is_active: true }}
                wrapperClasses={` ${(selectedMedicalInsuranceId !== null && selectedMedicalInsuranceId !== undefined) ? 'col-6' : 'col-12'} form-group px-0`} />

              {(selectedMedicalInsuranceId !== null && selectedMedicalInsuranceId !== undefined) &&
                <Field name="patient_medical_insurance_attributes[member_id]" component={Input} label="Member ID" className="form-control" wrapperClasses="col-6 form-group pe-0" validate={[required]} />
              }
              {/* <RadioGroup name="mode_of_notification" options={MODE_OF_NOTIFICATIONS} label={<span>Mode of Notification <span className="text-danger">{this.handleIsFieldRequired('mode_of_notification')}</span></span>} 
              wrapperClasses="col-12 form-group px-0" 
              validate={this.handleIsFieldRequired('mode_of_notification', true)}
               /> */}
              {/* <PatientModeOfNotification
                label={<span>Mode of Notification <span className="text-danger">{this.handleIsFieldRequired('mode_of_notification')}</span></span>}
                formName="appointmentForm"
                name="mode_of_notification"
                wrapperClasses="col-8 form-group px-0"
              /> */}
              <PatientModeOfNotification
                label={<span>Mode of Notification <span className="text-danger">{this.handleIsFieldRequired('mode_of_notification_type')}</span></span>}
                formName="appointmentForm"
                name="mode_of_notification_type"
                wrapperClasses="col-8 form-group px-0"
              />
            </div>
          </div>
          }
        </div>
        {(formType !== 'default') &&
          <div className="row w-100 m-0 px-5">
            <MultiSelect key={`appointment-${appointment.id}-procedures`} name="procedure_ids"
              placeholder="Reason For Visit *"
              data={procedures}
              defaultValues={appointment.procedure_ids}
              textField="friendly_name"
              valueField="settings_procedure_id"
              isAllSelectVisible={false}
              isSearchVisible={true}
              onSelectHook={(value) => { this.props.dispatch(change('appointmentForm', 'procedure_ids', value)) }}
              wrapperClasses="col-12 form-group px-0 appointment-step-3"
            />
            <Field name="comment" rows={1} component={Textarea} label="Comments" className="form-control" wrapperClasses="col-12 form-group px-0" />
          </div>
        }
        <Field label="Status" name="status" component={Select} textField="text" valueField="value" data={STATUSES} wrapperClasses="w-100 m-2 px-5 pb-6" />
        {isFullMode && <div className="modal-footer px-5 pb-7 pt-0 border-0">
          {formType === 'default' ?
            <a className="btn btn-link text-primary" onClick={() => handleAppointmentEditHandler({ formType: 'new' })}>Add New Patient</a> :
            !isTourActive && <button type="button" className="btn btn-link" onClick={() => { handleAppointmentEditHandler({ isFullMode: true }); }}>
              Full Mode
            </button>
          }
          <SaveButton buttonClasses={`${formType === 'default' && 'disabled'}`} saving={saving} />
        </div>}
      </form>
    );
  }
}

BookAppointmentForm = reduxForm({
  form: 'appointmentForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: (errors) => ScrollToTarget()
})(BookAppointmentForm)

const selector = formValueSelector('appointmentForm');

BookAppointmentForm = connect(state => {
  const { currentStore, appointment, setting: { patientTemplate: { patient_template }, calendarSetting } } = state
  const patientInsuranceData = patient_template.personal_information?.insurance_detail?.fields
  const selectedVisionInsuranceId = selector(state, 'patient_vision_insurance_attributes[settings_insurance_id]')
  const selectedMedicalInsuranceId = selector(state, 'patient_medical_insurance_attributes[settings_insurance_id]')
  const timeSlotFrequency = calendarSetting.calendar_setting.time_slot_frequency
  return {
    visionInsuranceTemplate: patientInsuranceData?.vision_insurance?.fields,
    medicalInsuranceTemplate: patientInsuranceData?.medical_insurance?.fields,
    staffs: currentStore.staffs,
    appointment: appointment,
    formType: appointment.handlerData.formType,
    selectedVisionInsuranceId,
    selectedMedicalInsuranceId,
    patientBasicDetailsTemplate: patient_template.personal_information.basic_details.fields,
    initialValues: {
      staff_id: currentStore.store.default_provider_id,
      ...appointment.appointment,
      mode_of_notification_type: patient_template.personal_information.basic_details?.fields?.mode_of_notification_type.default_value,
      start_time: appointment.appointment.start_time,
      end_time: new Date(appointment.appointment.start_time.getTime() + timeSlotFrequency * 60000),
    }
  }
})(BookAppointmentForm)

export default BookAppointmentForm;